export enum EnvEnum {
  PROD = 'production',
  STAGING = 'staging',
  DEVELOP = 'development',
  LOCAL = 'local',
  MOCK = 'mock',
}
